export default function getElement(name: string): HTMLElement | null {
  return document.querySelector(`[data-testid="${name}"]`)
}
